export const iconFontAwesomeMapsWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
